<script>
import ButtonNext from 'next/button/Button.vue';
import DropdownMenu from 'next/dropdown-menu/DropdownMenu.vue';
import Dropdown from 'next/wgpt/Dropdown/Dropdown.vue';

export default {
  components: {
    ButtonNext,
    DropdownMenu,
    Dropdown,
  },
  emits: ['delete', 'edit'],
  data() {
    return {
      contextMenuItems: [
        {
          label: this.$t(
            'WGPT_BOTS.EDIT.TABS.WORKFLOWS.BUTTON_TEXT.EDIT_WORKFLOW'
          ),
          action: 'edit',
          value: 'edit',
          icon: 'i-lucide-pencil',
        },
        {
          label: this.$t(
            'WGPT_BOTS.EDIT.TABS.WORKFLOWS.BUTTON_TEXT.DELETE_WORKFLOW'
          ),
          action: 'delete',
          value: 'delete',
          icon: 'i-lucide-trash',
        },
      ],
    };
  },
  methods: {
    handleAction({ action }, toggle) {
      if (action === 'edit') {
        this.$emit('edit');
      } else if (action === 'delete') {
        this.$emit('delete');
      }
      toggle();
    },
  },
};
</script>

<template>
  <div class="context-menu">
    <Dropdown>
      <template #trigger="{ toggle }">
        <ButtonNext
          icon="i-lucide-ellipsis-vertical"
          color="slate"
          size="xs"
          variant="ghost"
          class="rounded-md flex-shrink-0"
          @click="toggle"
        />
      </template>
      <template #default="{ toggle }">
        <DropdownMenu
          class="!static"
          :menu-items="contextMenuItems"
          @action="e => handleAction(e, toggle)"
        />
      </template>
    </Dropdown>
  </div>
</template>
